// eslint-disable-next-line no-shadow
export enum Language {
    En = 'en',
    Ru = 'ru',
    Fr = 'fr',
    PtBR = 'pt_BR',
    De = 'de',
    ZhCN = 'zh_CN',
    Es = 'es',
    Ja = 'ja',
    Tr = 'tr',
    It = 'it',
    Ko = 'ko',
}
